import { render, staticRenderFns } from "./ProjectToolbar.vue?vue&type=template&id=2c247b18&scoped=true"
import script from "./ProjectToolbar.vue?vue&type=script&lang=js"
export * from "./ProjectToolbar.vue?vue&type=script&lang=js"
import style0 from "./ProjectToolbar.vue?vue&type=style&index=0&id=2c247b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c247b18",
  null
  
)

export default component.exports